import { useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { SearchField } from '@statsbomb/kitbag-components';
import useTypingState from '../../utils/hooks/useTypingState';
import { StyledGlobalSearch } from './GlobalSearch.styles';
import { SEARCH_METADATA } from './searchMetadata';
import { ERROR_CODES } from '../../utils/errorCodes/errorCodes';
import GlobalSearchResults from './GlobalSearchResults';

const GlobalSearch = () => {
  const [isTyping, setIsTyping, searchString, setSearchValue] =
    useTypingState();
  const [isResultsOpen, setIsResultsOpen] = useState(false);

  const {
    data: searchData,
    loading: isLoading,
    error: searchError,
  } = useQuery(SEARCH_METADATA, {
    skip: isTyping,
    variables: {
      searchString,
    },
  });

  if (searchError) {
    console.error(ERROR_CODES.SEARCH_METADATA, searchError);
  }

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setIsTyping(true);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    setIsTyping(false);
  };

  return (
    <StyledGlobalSearch>
      <SearchField
        value={searchString}
        isLoading={isLoading}
        onChange={handleSearch}
        onClear={handleClearSearch}
        onClick={() => setIsResultsOpen(true)}
        placeholder="Search..."
        searchIconTitle="search"
        testId="globalSearchTest"
      />
      {isResultsOpen && searchData?.searchMetadata.length > 0 && (
        <GlobalSearchResults results={searchData?.searchMetadata} />
      )}
    </StyledGlobalSearch>
  );
};

export default GlobalSearch;
